import { render, staticRenderFns } from "./PanelDelimiter.vue?vue&type=template&id=6a24c194&scoped=true"
var script = {}
import style0 from "./PanelDelimiter.vue?vue&type=style&index=0&id=6a24c194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a24c194",
  null
  
)

export default component.exports